import React, { useState } from "react";
import "./furnishedROICalculator.css";

const FurnishedROICalculator = () => {
  const [bareRent, setBareRent] = useState("");
  const [furnRent, setFurnRent] = useState("");
  const [renoCost, setRenoCost] = useState("");
  const [result, setResult] = useState(null);

  const calculateROI = (e) => {
    e.preventDefault();
    const bare = parseFloat(bareRent) || 0;
    const furn = parseFloat(furnRent) || 0;
    const reno = parseFloat(renoCost) || 0;
    const monthlyPremium = furn - bare;
    if (monthlyPremium <= 0 || reno === 0) {
      setResult({
        error:
          "Furnished rent must be higher than unfurnished rent, and renovation costs must be greater than 0.",
      });
      return;
    }
    const breakEvenMonths = reno / monthlyPremium;
    const extraAnnualProfit = monthlyPremium * 12;
    setResult({
      monthlyPremium,
      breakEvenMonths,
      extraAnnualProfit,
      error: null,
    });
  };

  return (
    <div className="furnished-roi-calc-box">
      <h3>Furnished ROI Break-Even Calculator</h3>
      <form onSubmit={calculateROI}>
        <label>Current Unfurnished Rent (NPR/month):</label>
        <input
          type="number"
          value={bareRent}
          onChange={(e) => setBareRent(e.target.value)}
          placeholder="e.g. 25000"
        />
        <label>Expected Furnished Rent (NPR/month):</label>
        <input
          type="number"
          value={furnRent}
          onChange={(e) => setFurnRent(e.target.value)}
          placeholder="e.g. 60000"
        />
        <label>Estimated Furniture & Appliance Cost (NPR):</label>
        <input
          type="number"
          value={renoCost}
          onChange={(e) => setRenoCost(e.target.value)}
          placeholder="e.g. 400000"
        />
        <button type="submit">Calculate Break-Even</button>
      </form>
      {result &&
        (result.error ? (
          <div className="roi-error">{result.error}</div>
        ) : (
          <div className="roi-result">
            <p>
              <strong>Monthly Premium Earned:</strong> Rs.{" "}
              <span>{result.monthlyPremium.toLocaleString("en-IN")}</span>
            </p>
            <p>
              <strong>Months to Break Even:</strong>{" "}
              <span style={{ fontWeight: "bold", color: "#dc3545" }}>
                {result.breakEvenMonths.toFixed(1)}
              </span>{" "}
              months
            </p>
            <h4
              style={{ color: "#198754", fontSize: 18, margin: "15px 0 0 0" }}
            >
              Extra Annual Profit (After Break-Even): Rs.{" "}
              <span>{result.extraAnnualProfit.toLocaleString("en-IN")}</span>
            </h4>
          </div>
        ))}
    </div>
  );
};

export default FurnishedROICalculator;
